// const uploadUrl = 'https://test.vip-h5.com/admin/upload'
import axios from 'axios'
import { Message } from 'element-ui'

const letterArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']
const pwdRegx = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/
const loginNameRegx = /^[A-Za-z0-9_]{4,16}$/
// const emailRegx = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
const mobileRegx = /^1\d{10}$/
const floatRegx = /^(([1-9]\d*)|(0\.[1-9]\d{0,5})|(0\.\d{1,6})|([1-9]\d*\.\d{1,6}))$/
const id_card_18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
const id_card_15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
const $chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
const riskLevel = {
  'R1': '风险极低',
  'R2': '较低风险',
  'R3': '中等风险',
  'R4': '较高风险',
  'R5': '高风险',
}

const crdtTp = [
  { name: '身份证', code: '0' },
  { name: '中国护照', code: '1' },
  { name: '军官证', code: '2' },
  { name: '士兵证', code: '3' },
  { name: '港澳居民来往内地通行证', code: '4' },
  { name: '户口本', code: '5' },
  { name: '外国护照', code: '6' },
  { name: '其他', code: '7' },
  { name: '文职证', code: '8' },
  { name: '警官证', code: '9' },
  { name: '台胞证', code: 'A' },
  { name: '外国人永久居留身份证', code: 'B' },
  { name: '港澳台居民居住证', code: 'C' }
]

const orgCrdtTp = [
  {name: '组织机构代码证', code: '0'},
  {name: '营业执照', code: '1'},
  {name: '行政机关', code: '2'},
  {name: '社会团体法人登记证书', code: '3'},
  {name: '军队', code: '4'},
  {name: '武警', code: '5'},
  {name: '下属机构（具有主管单位批文号）', code: '6'},
  {name: '基金会', code: '7'},
  {name: '其他', code: '8'},
  {name: '登记证书', code: '9'},
  {name: '主管部门批文', code: 'A'},
]

const menus = [
  { id: 1, name: '个人信息', childNodes: [], shw: 'Y' },
  { id: 2, name: '账户查询', flag: '1', childNodes: [], shw: 'Y' },
  { id: 3, name: '持仓查询', flag: '1', childNodes: [], shw: 'Y' },
  { id: 6, name: '交易申请查询', flag: '1', childNodes: [],shw: 'Y' },
  { id: 4, name: '交易查询', flag: '1', childNodes: [], shw: 'Y' },
  { id: 5, name: '分红查询', flag: '1', childNodes: [], shw: 'Y' }
]
const menusMap = {
  '/user/index': { index: '1', title: '个人信息' },
  '/user/act': { index: '2', title: '账户查询' },
  '/user/hold': { index: '3', title: '持仓查询' },
  '/user/trd-apl-lst': { index: '6', title: '交易申请查询' },
  '/user/trd-cmf-lst': { index: '4', title: '交易查询' },
  '/user/bonus': { index: '5', title: '分红查询' }
}

const Dvdn_TpCd = {
  '0': '普通分红',
  '2': '货币产品收益结转',
  '6': '货币产品收益分配'
}

const CcyCd = {
  '156': '人民币',
  '840': '美元',
  '344': '港币',
  '978': '欧元',
  '826': '英镑'
}

const Scr_Txn_PsRlt_Cd = {
  '01': '未处理',
  '03': '确认成功',
  '04': '确认失败',
  '05': '撤单',
  '06': '预处理完成',
  '08': '冲正',
  '17': '一次确认成功'
}

const Fnd_Aply_TpCd = {
  '120': '认购确认',
  '122': '申购确认',
  '124': '赎回确认',
  '126': '转托管确认',
  '127': '转托管入确认',
  '128': '转托管出确认',
  '129': '修改分红方式确认',
  '130': '产品成立确认',
  '131': '份额冻结确认',
  '132': '份额解冻确认',
  '133': '非交易过户确认',
  '134': '非交易过户入确认',
  '135': '非交易过户出确认',
  '136': '产品转换确认',
  '137': '产品转换入确认',
  '138': '产品转换出确认',
  '139': '定期定额申购确认',
  '142': '强制赎回确认',
  '143': '红利发放确认',
  '144': '强制调增确认',
  '145': '强制调减确认',
  '149': '发行失败确认',
  '150': '产品清盘确认',
  '151': '产品终止确认',
  '198': '快速过户确认',
  '196': '快速过户出确认',
  '197': '快速过户入确认',
  '310': '购买撤单确认',
  '199': '展期确认'
}

const nation= [
  { value: '01', label: '汉族' },
  { value: '02', label: '蒙古族' },
  { value: '03', label: '回族' },
  { value: '04', label: '藏族' },
  { value: '05', label: '维吾尔族' },
  { value: '06', label: '苗族' },
  { value: '07', label: '彝族' },
  { value: '08', label: '壮族' },
  { value: '09', label: '布依族' },
  { value: '10', label: '朝鲜族' },
  { value: '11', label: '满族' },
  { value: '12', label: '侗族' },
  { value: '13', label: '瑶族' },
  { value: '14', label: '白族' },
  { value: '15', label: '土家族' },
  { value: '16', label: '哈尼族' },
  { value: '17', label: '哈萨克族' },
  { value: '18', label: '傣族' },
  { value: '19', label: '黎族' },
  { value: '20', label: '傈僳族' },
  { value: '21', label: '佤族' },
  { value: '22', label: '畲族' },
  { value: '23', label: '高山族' },
  { value: '24', label: '拉祜族' },
  { value: '25', label: '水族' },
  { value: '26', label: '东乡族' },
  { value: '27', label: '纳西族' },
  { value: '28', label: '景颇族' },
  { value: '29', label: '柯尔克孜族' },
  { value: '30', label: '土族' },
  { value: '31', label: '达斡尔族' },
  { value: '32', label: '仫佬族' },
  { value: '33', label: '羌族' },
  { value: '34', label: '布朗族' },
  { value: '35', label: '撒拉族' },
  { value: '36', label: '毛南族' },
  { value: '37', label: '仡佬族' },
  { value: '38', label: '锡伯族' },
  { value: '39', label: '阿昌族' },
  { value: '40', label: '普米族' },
  { value: '41', label: '塔吉克族' },
  { value: '42', label: '怒族' },
  { value: '43', label: '乌孜别克族' },
  { value: '44', label: '俄罗斯族' },
  { value: '45', label: '鄂温克族' },
  { value: '46', label: '德昂族' },
  { value: '47', label: '保安族' },
  { value: '48', label: '裕固族' },
  { value: '49', label: '京族' },
  { value: '50', label: '塔塔尔族' },
  { value: '51', label: '独龙族' },
  { value: '52', label: '鄂伦春族' },
  { value: '53', label: '赫哲族' },
  { value: '54', label: '门巴族' },
  { value: '55', label: '珞巴族' },
  { value: '56', label: '基诺族' },
  { value: '57', label: '外国血统中国籍人士' },
  { value: '99', label: '其他' }
]

const country = [
  { value: '008', label: '阿尔巴尼亚' },
  { value: '012', label: '阿尔及利亚' },
  { value: '004', label: '阿富汗' },
  { value: '032', label: '阿根廷' },
  { value: '784', label: '阿联酋' },
  { value: '533', label: '阿鲁巴' },
  { value: '512', label: '阿曼' },
  { value: '031', label: '阿塞拜疆' },
  { value: '818', label: '埃及' },
  { value: '231', label: '埃塞俄比亚' },
  { value: '372', label: '爱尔兰' },
  { value: '233', label: '爱沙尼亚' },
  { value: '020', label: '安道尔' },
  { value: '024', label: '安哥拉' },
  { value: '660', label: '安圭拉' },
  { value: '028', label: '安提瓜和巴布达' },
  { value: '040', label: '奥地利' },
  { value: '248', label: '奥兰群岛' },
  { value: '036', label: '澳大利亚' },
  { value: '446', label: '澳门' },
  { value: '052', label: '巴巴多斯' },
  { value: '598', label: '巴布亚新几内亚' },
  { value: '044', label: '巴哈马' },
  { value: '586', label: '巴基斯坦' },
  { value: '600', label: '巴拉圭' },
  { value: '275', label: '巴勒斯坦' },
  { value: '048', label: '巴林' },
  { value: '591', label: '巴拿马' },
  { value: '076', label: '巴西' },
  { value: '112', label: '白俄罗斯' },
  { value: '060', label: '百慕大' },
  { value: '100', label: '保加利亚' },
  { value: '580', label: '北马里亚纳' },
  { value: '204', label: '贝宁' },
  { value: '056', label: '比利时' },
  { value: '352', label: '冰岛' },
  { value: '630', label: '波多黎各' },
  { value: '616', label: '波兰' },
  { value: '070', label: '波斯尼亚和黑塞哥维那' },
  { value: '068', label: '玻利维亚' },
  { value: '084', label: '伯利兹' },
  { value: '072', label: '博茨瓦纳' },
  { value: '535', label: '博奈尔、圣尤斯特歇斯和萨巴岛' },
  { value: '064', label: '不丹' },
  { value: '854', label: '布基纳法索' },
  { value: '108', label: '布隆迪' },
  { value: '074', label: '布维岛' },
  { value: '408', label: '朝鲜' },
  { value: '226', label: '赤道几内亚' },
  { value: '208', label: '丹麦' },
  { value: '276', label: '德国' },
  { value: '626', label: '东帝汶' },
  { value: '768', label: '多哥' },
  { value: '214', label: '多米尼加' },
  { value: '212', label: '多米尼克' },
  { value: '643', label: '俄罗斯联邦' },
  { value: '218', label: '厄瓜多尔' },
  { value: '232', label: '厄立特里亚' },
  { value: '250', label: '法国' },
  { value: '234', label: '法罗群岛' },
  { value: '258', label: '法属伯利尼西亚' },
  { value: '254', label: '法属圭亚那' },
  { value: '260', label: '法属南部领地' },
  { value: '663', label: '法属圣马丁' },
  { value: '336', label: '梵蒂冈' },
  { value: '608', label: '菲律宾' },
  { value: '242', label: '斐济' },
  { value: '246', label: '芬兰' },
  { value: '132', label: '佛得角' },
  { value: '238', label: '福克兰群岛（马尔维纳斯）' },
  { value: '270', label: '冈比亚' },
  { value: '178', label: '刚果（布）' },
  { value: '180', label: '刚果（金）' },
  { value: '170', label: '哥伦比亚' },
  { value: '188', label: '哥斯达黎加' },
  { value: '831', label: '格恩西岛' },
  { value: '308', label: '格林纳达' },
  { value: '304', label: '格陵兰' },
  { value: '268', label: '格鲁吉亚' },
  { value: '192', label: '古巴' },
  { value: '312', label: '瓜德罗普' },
  { value: '316', label: '关岛' },
  { value: '328', label: '圭亚那' },
  { value: '398', label: '哈萨克斯坦' },
  { value: '332', label: '海地' },
  { value: '410', label: '韩国' },
  { value: '528', label: '荷兰' },
  { value: '534', label: '荷属圣马丁岛' },
  { value: '334', label: '赫德岛和麦克唐纳岛' },
  { value: '499', label: '黑山共和国' },
  { value: '340', label: '洪都拉斯' },
  { value: '296', label: '基里巴斯' },
  { value: '262', label: '吉布提' },
  { value: '417', label: '吉尔吉斯斯坦' },
  { value: '324', label: '几内亚' },
  { value: '624', label: '几内亚比绍' },
  { value: '124', label: '加拿大' },
  { value: '288', label: '加纳' },
  { value: '266', label: '加蓬' },
  { value: '116', label: '柬埔寨' },
  { value: '203', label: '捷克' },
  { value: '716', label: '津巴布韦' },
  { value: '120', label: '喀麦隆' },
  { value: '634', label: '卡塔尔' },
  { value: '136', label: '开曼群岛' },
  { value: '166', label: '科科斯（基林）群岛' },
  { value: '174', label: '科摩罗' },
  { value: '384', label: '科特迪瓦' },
  { value: '414', label: '科威特' },
  { value: '191', label: '克罗地亚' },
  { value: '404', label: '肯尼亚' },
  { value: '184', label: '库克群岛' },
  { value: '531', label: '库拉索' },
  { value: '428', label: '拉脱维亚' },
  { value: '426', label: '莱索托' },
  { value: '418', label: '老挝' },
  { value: '422', label: '黎巴嫩' },
  { value: '440', label: '立陶宛' },
  { value: '430', label: '利比里亚' },
  { value: '434', label: '利比亚' },
  { value: '438', label: '列支敦士登' },
  { value: '638', label: '留尼汪' },
  { value: '442', label: '卢森堡' },
  { value: '646', label: '卢旺达' },
  { value: '642', label: '罗马尼亚' },
  { value: '450', label: '马达加斯加' },
  { value: '833', label: '马恩岛' },
  { value: '462', label: '马尔代夫' },
  { value: '470', label: '马耳他' },
  { value: '454', label: '马拉维' },
  { value: '458', label: '马来西亚' },
  { value: '466', label: '马里' },
  { value: '584', label: '马绍尔群岛' },
  { value: '474', label: '马提尼克' },
  { value: '175', label: '马约特' },
  { value: '480', label: '毛里求斯' },
  { value: '478', label: '毛里塔尼亚' },
  { value: '840', label: '美国' },
  { value: '581', label: '美国本土外小岛屿' },
  { value: '016', label: '美属萨摩亚' },
  { value: '850', label: '美属维尔京群岛' },
  { value: '496', label: '蒙古' },
  { value: '500', label: '蒙特塞拉特' },
  { value: '050', label: '孟加拉国' },
  { value: '604', label: '秘鲁' },
  { value: '583', label: '密克罗尼西亚联邦' },
  { value: '104', label: '缅甸' },
  { value: '498', label: '摩尔多瓦' },
  { value: '504', label: '摩洛哥' },
  { value: '492', label: '摩纳哥' },
  { value: '508', label: '莫桑比克' },
  { value: '484', label: '墨西哥' },
  { value: '516', label: '纳米比亚' },
  { value: '710', label: '南非' },
  { value: '010', label: '南极洲' },
  { value: '239', label: '南乔治亚岛和南桑德维奇岛' },
  { value: '728', label: '南苏丹' },
  { value: '520', label: '瑙鲁' },
  { value: '524', label: '尼泊尔' },
  { value: '558', label: '尼加拉瓜' },
  { value: '562', label: '尼日尔' },
  { value: '566', label: '尼日利亚' },
  { value: '570', label: '纽埃' },
  { value: '578', label: '挪威' },
  { value: '574', label: '诺福克岛' },
  { value: '585', label: '帕劳' },
  { value: '612', label: '皮特凯恩' },
  { value: '620', label: '葡萄牙' },
  { value: '807', label: '前南马其顿' },
  { value: '392', label: '日本' },
  { value: '752', label: '瑞典' },
  { value: '756', label: '瑞士' },
  { value: '222', label: '萨尔瓦多' },
  { value: '882', label: '萨摩亚' },
  { value: '688', label: '塞尔维亚' },
  { value: '891', label: '塞尔维亚和黑山共和国' },
  { value: '694', label: '塞拉利昂' },
  { value: '686', label: '塞内加尔' },
  { value: '196', label: '塞浦路斯' },
  { value: '690', label: '塞舌尔' },
  { value: '682', label: '沙特阿拉伯' },
  { value: '652', label: '圣巴泰勒米岛' },
  { value: '162', label: '圣诞岛' },
  { value: '678', label: '圣多美和普林西比' },
  { value: '654', label: '圣赫勒拿' },
  { value: '659', label: '圣基茨和尼维斯' },
  { value: '662', label: '圣卢西亚' },
  { value: '674', label: '圣马力诺' },
  { value: '666', label: '圣皮埃尔和密克隆' },
  { value: '670', label: '圣文森特和格林纳丁斯' },
  { value: '144', label: '斯里兰卡' },
  { value: '703', label: '斯洛伐克' },
  { value: '705', label: '斯洛文尼亚' },
  { value: '744', label: '斯瓦尔巴岛和养马延岛' },
  { value: '748', label: '斯威士兰' },
  { value: '729', label: '苏丹' },
  { value: '740', label: '苏里南' },
  { value: '090', label: '所罗门群岛' },
  { value: '706', label: '索马里' },
  { value: '762', label: '塔吉克斯坦' },
  { value: '764', label: '泰国' },
  { value: '834', label: '坦桑尼亚' },
  { value: '776', label: '汤加' },
  { value: '796', label: '特克斯和凯克斯群岛' },
  { value: '780', label: '特立尼达和多巴哥' },
  { value: '788', label: '突尼斯' },
  { value: '798', label: '图瓦卢' },
  { value: '792', label: '土耳其' },
  { value: '795', label: '土库曼斯坦' },
  { value: '772', label: '托克劳' },
  { value: '876', label: '瓦利斯和富图纳' },
  { value: '548', label: '瓦努阿图' },
  { value: '320', label: '危地马拉' },
  { value: '862', label: '委内瑞拉' },
  { value: '096', label: '文莱' },
  { value: '800', label: '乌干达' },
  { value: '804', label: '乌克兰' },
  { value: '858', label: '乌拉圭' },
  { value: '860', label: '乌兹别克斯坦' },
  { value: '724', label: '西班牙' },
  { value: '732', label: '西撒哈拉' },
  { value: '300', label: '希腊' },
  { value: '702', label: '新加坡' },
  { value: '540', label: '新喀里多尼亚' },
  { value: '554', label: '新西兰' },
  { value: '348', label: '匈牙利' },
  { value: '760', label: '叙利亚' },
  { value: '388', label: '牙买加' },
  { value: '051', label: '亚美尼亚' },
  { value: '887', label: '也门' },
  { value: '368', label: '伊拉克' },
  { value: '364', label: '伊朗' },
  { value: '376', label: '以色列' },
  { value: '380', label: '意大利' },
  { value: '356', label: '印度' },
  { value: '360', label: '印度尼西亚' },
  { value: '826', label: '英国' },
  { value: '092', label: '英属维尔京群岛' },
  { value: '086', label: '英属印度洋领地' },
  { value: '400', label: '约旦' },
  { value: '704', label: '越南' },
  { value: '894', label: '赞比亚' },
  { value: '832', label: '泽西岛' },
  { value: '148', label: '乍得' },
  { value: '292', label: '直布罗陀' },
  { value: '152', label: '智利' },
  { value: '140', label: '中非' },
  { value: '156', label: '中国' },
  { value: '158', label: '中国台湾' },
  { value: '344', label: '中国香港' },
  { value: '999', label: '其他国家和地区' }
]
export function randomString(len) {
  len = len || 32
  let maxPos = 62
  let str = ''
  for (let i = 0; i < len; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return str
}

export function toHex(str) {
  return Array.prototype.map.call(str, c => {
    return c.charCodeAt(0).toString(16)
  }).join("")
}

export function getCrdtTpNm(code) {
  let r
  this.crdtTp.forEach(c => {
    if (c.code === code) {
      r = c
      return r
    }
  })
  return r ? r.name : ''
}

export function replace(src, regx, replace) {
  if (src && src.length > 0) {
    return src.replace(regx, replace)
  } else {
    return src
  }
}

export function netFmt(val) {
  let p = Number.parseFloat(val)
  if (Number.isNaN(p)) {
    return '--'
  }
  return p.toFixed(6)
}

export function fmtDtStr(dt) {
  if (dt && dt.length >= 8) {
    return dt.substring(0, 4) + '-' + dt.substring(4, 6) + '-' + dt.substring(6)
  }
  return '--'
}

export function getOrgCrdtTpNm(code) {
  let r
  this.orgCrdtTp.forEach(c => {
    if (c.code === code) {
      r = c
      return r
    }
  })
  return r ? r.name : ''
}

export function fmtDt(dt) {
  let y = dt.getFullYear()
  let m = dt.getMonth() + 1
  let d = dt.getDate()
  return fmtNum(y) + fmtNum(m) + fmtNum(d)
}

export function fmtNum(dt) {
  return dt < 10 ? '0' + dt : dt + ''
}

export function fmtDate (date) {
  return date.getFullYear() + '-' + fmtNum(date.getMonth() + 1) + '-' + fmtNum(date.getDate())
}

export function getHtml (name) {
  return axios.get('/resource/static/content/' + name + '.html').then(res => {
      return Promise.resolve(res)
    }).catch(err => {
      if (err.response.status === 404) {
        return Promise.resolve({ data: '<div class="s-404"><img src="../static/404.png" /></div>' })
      } else if (err.code === 'ECONNABORTED' && !err.config_retry) {
        err.config_retry = true
        return axios.request(err.config)
      } else {
        Message({ message: err.message, type: 'error' })
        Promise.reject(err)
      }
    })
}

export function scale(){
  return document.documentElement.clientWidth / 1920
}

export function isMobile() {
  const userAgent = navigator.userAgent;
  const mobileKeywords = ['Mobile', 'Android', 'iPhone', 'iPad', 'Windows Phone'];

  for (let i = 0; i < mobileKeywords.length; i++) {
    if (userAgent.indexOf(mobileKeywords[i]) !== -1) {
      return true;
    }
  }
  return false;
}

export default {
  isMobile,
  getHtml,
  fmtDate,
  netFmt,
  letterArr,
  pwdRegx,
  loginNameRegx,
  // emailRegx,
  mobileRegx,
  floatRegx,
  id_card_18,
  id_card_15,
  scale,
  crdtTp,
  orgCrdtTp,
  nation,
  country,
  riskLevel,
  menus,
  menusMap,
  getOrgCrdtTpNm,
  getCrdtTpNm,
  Fnd_Aply_TpCd,
  Scr_Txn_PsRlt_Cd,
  CcyCd,
  Dvdn_TpCd,
  fmtDtStr,
  replace,
  toHex,
  disabledDate: date => {
    const d = date.getTime() + 24 * 60 * 60 * 1000
    return d < new Date().getTime()
  }
}
